import { IonicModule } from "@ionic/angular";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";

import { HomePageRoutingModule } from "./home-routing.module";
import { ComponentsModule } from "src/app/components/components.module";

import { HomePage } from "./home.page";
import { SliderComponent } from "src/app/components/slider/slider.component";
import { OutstandingContentComponent } from "src/app/components/outstanding-content/outstanding-content.component";

import { PipesModule } from "src/app/pipes/pipes.module";
import { KpiModule } from "src/app/components/kpi/kpi.module";

@NgModule({
  imports: [
    IonicModule,
    CommonModule,
    FormsModule,
    HomePageRoutingModule,
    ComponentsModule,
    PipesModule,
    KpiModule
  ],
  declarations: [HomePage, SliderComponent, OutstandingContentComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class HomePageModule {}
